// VFX: Stat Impact Card
// Category: counters  ·  Tags: ui, stat, counter, impact, number
// Large number with countUp and radial glow.
import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate} from "remotion";
const clamp = {extrapolateLeft:"clamp",extrapolateRight:"clamp"} as const;
export const StatImpactCard: React.FC<{
  value?: number; prefix?: string; suffix?: string;
  label?: string; accentColor?: string; dark?: boolean;
}> = ({value=98, prefix="", suffix="%", label="of AI agents fail", accentColor="#ff6b35", dark=true}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();
  const p = spring({frame, fps, config:{damping:100, stiffness:180, mass:0.8}});
  const countVal = Math.round(interpolate(p,[0,1],[0,value],clamp));
  const glow = Math.sin(frame*0.05)*0.08+0.22;
  return (
    <AbsoluteFill style={{background: dark?"#000000":"#ffffff", justifyContent:"center", alignItems:"center"}}>
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 65% 50% at 50% 50%, ${accentColor}${Math.round(glow*255).toString(16).padStart(2,"0")} 0%, transparent 60%)`}} />
      <div style={{position:"absolute",inset:0,backgroundImage:"url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.05'/%3E%3C/svg%3E\")",opacity:0.5}} />
      <div style={{position:"relative",textAlign:"center",zIndex:1}}>
        <div style={{
          fontSize:160, fontWeight:900, lineHeight:1,
          color: accentColor, opacity: p,
          transform:`scale(${interpolate(p,[0,1],[0.6,1],clamp)})`,
          fontFamily:"system-ui, sans-serif", letterSpacing:"-4px",
          textShadow:`0 0 60px ${accentColor}66`,
        }}>{prefix}{countVal}{suffix}</div>
        {label && (
          <div style={{
            fontSize:28, fontWeight:300, color: dark?"rgba(255,255,255,0.7)":"rgba(0,0,0,0.6)",
            opacity: interpolate(frame,[15,30],[0,1],clamp), marginTop:8, letterSpacing:"0.5px"
          }}>{label}</div>
        )}
      </div>
    </AbsoluteFill>
  );
};

export default function UiStatCardImpact800Ms() {
  return <StatImpactCard />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
